var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5C5.13401 5 2 8.13401 2 12C2 15.866 5.13401 19 9 19H17.9486C20.0966 18.7715 21.2312 17.7294 21.6965 16.5661C22.1831 15.3496 22.008 13.83 21.1831 12.5776C20.5504 11.7412 19.977 11.388 19.372 11.2088C18.6944 11.0081 17.9133 11 16.748 11H15.9728L15.7795 10.2493C15.0024 7.2299 12.2603 5 9 5ZM0 12C0 7.02944 4.02944 3 9 3C12.9206 3 16.2536 5.50606 17.4884 9.00244C18.3276 9.01217 19.159 9.05985 19.94 9.29118C21.0176 9.61038 21.9394 10.2525 22.8 11.4L22.8167 11.4222L22.8321 11.4453C23.9942 13.1885 24.3139 15.4079 23.5535 17.3089C22.7722 19.262 20.9203 20.713 18.0995 20.995L18.0499 21H9C4.02944 21 0 16.9706 0 12Z",
    fill: "#02BF8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudNew);
export default __webpack_public_path__ + "static/media/cloud-new.74eef65e.svg";
export { ForwardRef as ReactComponent };